import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { AppState } from 'src/app/app.state';
import constants from 'src/constant.json';
import { ReportsState } from '../../../reports/reports.state';

@Component({
  selector: 'app-status-info',
  templateUrl: './status-info.component.html',
  styleUrls: ['./status-info.component.scss'],
})
export class StatusInfoComponent implements OnInit {
  requestStatus: any = '';
 companyName:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private reportState: ReportsState,
    private appState : AppState,
    private router :Router,
    private authorizeService :AuthorizeService
  ) {

  }

  ngOnInit() {
 const alias = this.appState?.companyInfoValue?.alias;
const companyKey = alias?.toUpperCase();
this.companyName = constants.COMPANY_NAME[companyKey] || alias;
    let onboardRequestStatus = history.state.data;
    if (onboardRequestStatus && onboardRequestStatus.res && onboardRequestStatus.res.status) {
      this.requestStatus = onboardRequestStatus.res.message;

    } else {
      this.requestStatus =
        onboardRequestStatus.error && onboardRequestStatus.error.message
          ? onboardRequestStatus.error.message
          : 'Request Failed';
    } 
  }
  
  redirection(){
    if (this.appState.companyInfoValue?.alias === 'valuetest') {
      this.router.navigate(['/signup']);
    } else if (this.appState.companyInfoValue?.alias === 'opscan') {
      this.router.navigate(['/login']);
    } else if (this.appState.companyInfoValue?.alias === 'rubyporch') {
      this.router.navigate(['/login']);
    } else {
       this.router.navigate(['/workspace/map'])
      setTimeout(() => {
        this.authorizeService.openLogInDialog();
      }, 500);
    } 
  }
  
}
